<template>
    <v-container>
        <h1>Remplacements</h1>
        <v-divider></v-divider>
        <h2>Demandes de remplacement</h2>
        <v-data-table
            :headers="fieldsDemandes"
            :items="demandes"
            :items-per-page="10"
            :sort-by.sync="sortByDemandes"
            :sort-desc.sync="sortDescDemandes"
            class="elevation-1"
            :loading="loading"
            loading-text="Chargement..."
        >
        <template v-slot:item.horaire.date="{ item }">
            {{utils.toPrettyDate(item.horaire.date)}}
        </template>
        <template v-slot:item.horaire.id_fonction="{item}">{{fonctionsById[item.horaire.id_fonction].nom}}</template>      
        <template v-slot:item.horaire.id_site="{item}">{{sitesById[item.horaire.id_site].nom}}</template>  
        <template v-slot:item.sceances="{item}">
            <seances :item="item.horaire" />
        </template>
        <template v-slot:item.demandeur="{item}">
            {{employesById[item.horaire.id_employe].nom}} {{employesById[item.horaire.id_employe].prenom}}
        </template>
        <template v-slot:item.proposer="{item}"><v-btn class="success" @click="remplacer(item)" dense><v-icon>mdi-swap-horizontal</v-icon>Remplacer</v-btn></template>
        </v-data-table>
        <h2>Mes demandes</h2>
                <v-data-table
            :headers="fieldsMesDemandes"
            :items="mesDemandes"
            :items-per-page="10"
            :sort-by.sync="sortByMesDemandes"
            :sort-desc.sync="sortDescMesDemandes"
            class="elevation-1"
            :loading="loading"
            loading-text="Chargement..."
        >
        <template v-slot:item.horaire.date="{ item }">
            {{utils.toPrettyDate(item.horaire.date)}}
        </template>
        <template v-slot:item.horaire.id_fonction="{item}">{{fonctionsById[item.horaire.id_fonction].nom}}</template>      
        <template v-slot:item.horaire.id_site="{item}">{{sitesById[item.horaire.id_site].nom}}</template>  
        <template v-slot:item.sceances="{item}">
            <seances :item="item.horaire" />
        </template>
        <template v-slot:item.status="{item}">
            <v-chip v-if="item.status === 0" color="primary">En attente de proposition</v-chip>
            <v-chip v-if="item.status === 1" color="accent">En attente de validation</v-chip>
            <v-chip v-if="item.status === 2" color="success">Validé</v-chip>
            <v-chip v-if="item.status === 3" color="error">Refusé</v-chip>
            <v-chip v-if="item.status === 4" color="error">Annulé</v-chip>        
        </template>
        <template v-slot:item.remplacant="{item}">
            <span
          v-if="item.id_remplacant"
            >{{employesById[item.id_remplacant].prenom}} {{employesById[item.id_remplacant].nom}}</span>
            <span v-else>-</span>
        </template>
        <template v-slot:item.annuler="{item}"><v-btn class="error" @click="annuler(item)" dense><v-icon>mdi-delete</v-icon>Annuler</v-btn></template>
        </v-data-table>
        <h2>QSP</h2>
        <v-data-table
            :headers="fieldsQSP"
            :items="qsp"
            :items-per-page="10"
            :sort-by.sync="sortByQSP"
            :sort-desc.sync="sortDescQSP"
            class="elevation-1"
            :loading="loading"
            loading-text="Chargement..."
        >
        <template v-slot:item.date="{ item }">
            {{utils.toPrettyDate(item.date)}}
        </template>
        <template v-slot:item.id_fonction="{item}">{{fonctionsById[item.id_fonction].nom}}</template>      
        <template v-slot:item.id_site="{item}">{{sitesById[item.id_site].nom}}</template>  
        <template v-slot:item.sceances="{item}">
            <seances :item="item" />
        </template>
        <template v-slot:item.proposer="{item}"><v-btn class="success" @click="proposerQSP(item)" dense><v-icon>mdi-hand-back-left</v-icon>Me proposer</v-btn></template>
        </v-data-table>
    </v-container>
</template>

<script>
import utils from "@/utils";
import api from "@/api";
import Seances from "@/components/Seances";
import store from "@/store";

export default {
  data() {
    return {
      demandes: [],
      mesDemandes: [],
      qsp: [],
      utils,
      employes: [],
      employesById: [],
      sites: [],
      sitesById: [],
      fonctions: [],
      fonctionsById: [],
      sortByDemandes: "horaire.date",
      sortDescDemandes: false,
      fieldsDemandes: [
        { value: "horaire.date", text: "Date", sortable: true },
        { value: "horaire.id_site", text: "Site", sortable: true },
        { value: "horaire.id_fonction", text: "Fonction", sortable: true },
        { value: "sceances", text: "Scéances", sortable: false },
        { value: "demandeur", text: "Demandé par", sortable: false },
        { value: "proposer", text: "Me proposer", sortable: false }
      ],
      sortByMesDemandes: "horaire.date",
      sortDescMesDemandes: false,
      fieldsMesDemandes: [
        { value: "horaire.date", text: "Date", sortable: true },
        { value: "horaire.id_site", text: "Site", sortable: true },
        { value: "horaire.id_fonction", text: "Fonction", sortable: true },
        { value: "sceances", text: "Scéances", sortable: false },
        { value: "status", text: "Status", sortable: true },
        { value: "remplacant", text: "Remplaçant", sortable: false },
        { value: "annuler", text: "Annuler", sortable: false }
      ],
      sortByQSP: "date",
      sortDescQSP: false,
      fieldsQSP: [
        { value: "date", text: "Date", sortable: true },
        { value: "id_site", text: "Site", sortable: true },
        { value: "id_fonction", text: "Fonction", sortable: true },
        { value: "sceances", text: "Scéances", sortable: false },
        { value: "remarque", text: "Remarque", sortable: false },
        { value: "proposer", text: "Me proposer", sortable: false }
      ]
    };
  },
  components: {Seances},
  async created() {
    this.loadData();
  },
  methods: {
    async loadData(){
      this.$store.commit("setLoading", true);
      this.employes = (await api.getEmployes()).data.employes;
      for (let employe of this.employes) {
        this.employesById[employe.id] = employe;
      }
      this.sites = (await api.getSites()).data.sites;
      for (let site of this.sites) {
        this.sitesById[site.id] = site;
      }
      this.fonctions = (await api.getFonctions()).data.fonctions;
      for (let fonction of this.fonctions) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.mesDemandes = (await api.getMesDemandes()).data.remplacements;
      this.demandes = (await api.getRemplacementsDemandes()).data.remplacements;
      this.qsp = (await api.getQSPs()).data.qsp;
      this.$store.commit("setLoading", false);
    },
    async remplacer(demande) {
      this.$swal.fire({
        title: "Es-tu sûr de vouloir te proposer?",
        text: "Tu t'engage à remplacer cette personne si la demande est acceptée",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non"
      }).then(async result => {
        if (result.value) {
          let response = await api.proposerRemplacement(demande.id);
          this.$swal.fire({
            type: response.code === 200 ? "success" : "error",
            text: response.message
          });
          if (response.code === 200)
            this.demandes.splice(this.demandes.indexOf(demande), 1);
        }
      });
    },
    async annuler(demande){
      this.$swal.fire({
        title: "Annuler la demande de remplacement?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non"
      }).then(async result => {
        if (result.value) {
          let response = await api.annulerRemplacement(demande.id);
          this.$swal.fire({
            type: response.code === 200 ? "success" : "error",
            text: response.message
          });
          if (response.code === 200)
            demande.status = 4;
        }
      });
    },
    async proposerQSP(qsp) {
      const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
            });
      let result = await api.proposerQSP(qsp.id);
      Toast.fire({
        type: result.code === 200 ? "success" : "error",
        text: result.message
      });
      if (result.code === 200) {
        this.qsp.splice(this.qsp.indexOf(qsp), 1);
      }
    }
  },
  computed: {
    loading() {
      return store.state.loading;
    },
  }
};
</script>